import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { StripeCallbackPage } from '@/features/payment-methods';

/** Stripe Connect sends the owner back here (the backend builds this redirect URI). */
export const Route = createFileRoute(
  '/_authed/_active/s/$storeId/settings/payments/stripe/callback',
)({
  staticData: { crumb: 'common:nav.paymentMethods' },
  validateSearch: z.object({
    code: z.string().optional(),
    state: z.string().optional(),
    error: z.string().optional(),
  }),
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.write');
  },
  component: StripeCallbackRoute,
});

function StripeCallbackRoute() {
  const { storeId } = Route.useParams();
  const { code, state, error } = Route.useSearch();
  return <StripeCallbackPage storeId={storeId} code={code} state={state} error={error} />;
}
